import {
  formatTimegridAppointmentTime,
  minutesToThreeDigitsTime,
} from 'Data/format.js'

export function getSlotLabel(templatedSlots, templatedSlot, untemplatedSlot) {
  // Selected slot is untemplated
  if (untemplatedSlot?.date) {
    let { date, start_min, end_min } = untemplatedSlot
    return `${formatTimegridAppointmentTime({
      start: `${date}T${minutesToThreeDigitsTime(start_min)}`,
      end: `${date}T${minutesToThreeDigitsTime(end_min)}`,
    })} ( ${untemplatedSlot.chair_name} )`
  }

  // Selected slot is templated
  if (templatedSlot) {
    let selected = templatedSlots?.find(item => item.id === templatedSlot)
    if (selected) return `${selected.time_formatted} ( ${selected.chair_name} )`
  }

  // No slot selected
  return 'Slot'
}
